export default __webpack_public_path__ + "static/banner-retail-9f91e1ac6560eff60937df9eafd32621.webp";